/**
 * Enum for check-in cadence
 * Defines how frequently a check-in occurs
 */
export enum CheckInCadence {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  BI_WEEKLY = 'BI_WEEKLY',
  MONTHLY = 'MONTHLY',
  ONE_OFF = 'ONE_OFF', // Includes both one-off and previously on-demand check-ins
}

/**
 * Enum for question format
 * Defines the structure of a question's response
 */
export enum QuestionFormat {
  STRING = 'STRING',
  ARRAY = 'ARRAY',
  OBJECT = 'OBJECT',
} 